import { CSSProperties, useEffect } from "react";
import { HtmlHelper } from "../../utils/HtmlHelper";
import { Modal } from "antd";

export type SFModalProps = {
  open: boolean;
  name?: string;
  toggler: Function;
  title?: string;
  body?: JSX.Element;
  footer?: () => JSX.Element;
  width?: number;
  style?: CSSProperties;
}

export const SFModal = (props: SFModalProps) => {
  const handleModalClose = () => {
    props.toggler && props.toggler();
  };

  return (

    <Modal
      destroyOnClose
      style={props.style}
      title={props.title}
      footer={props.footer ? props.footer : <></>}
      open={props.open}
      onCancel={handleModalClose}
      onClose={handleModalClose}
      width={props.width}
    >
      {props.body && props.body}
    </Modal>
  );
};
